import * as accountsApi from '@/network/api/accounts.api.js'
import * as creditApi from '@/network/api/credit.api.js'

/** Request Accounts Balances
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
@return {promise} - Accounts Balances
*/
export const requestAccountsBalances = async (context, payload) => {
	const res = await accountsApi.requestAccountsBalances(payload)
	if (res) context.commit('SAVE_ACCOUNTS_BALANCE', res.data.data)
	return res
}

/** Amortize a credit account
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetcreditaccounts%7BaccountToAmortizeId%7Dsettlement
@payload {Object} payload.accountToAmortizeId
@return {promise}
*/
export const amortizeCreditAccount = async (context, payload) => {
	const res = await creditApi.amortizeCreditAccount(payload)
	return res
}

/** Partial Amortization of credit account
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetcreditaccounts%7BaccountToAmortizeId%7DpartialSettlement
@payload {Object} payload.accountToAmortizeId
@return {promise}
*/
export const partialAmortizeCreditAccount = async (context, payload) => {
	const res = await creditApi.partialAmortizeCreditAccount(payload)
	return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
